import Button from '@/components/form/button'
import LinkHome from '@/components/links/home'
import Logo from '@icon/variable/logo.svg'
import { cn } from '@utils'
import { Suspense } from 'react'
import { HeaderProps } from './header.types'
import { MobileMenu } from './mobileMenu'
import {
  HeaderMenuButton,
  HeaderMenuContextProvider,
} from './mobileMenu/content'
import Nav from './nav'
import HeaderSticky from './sticky'

export default function Header({ className = '', sticky = true }: HeaderProps) {
  return (
    <HeaderMenuContextProvider>
      <HeaderSticky sticky={sticky}>
        <header
          className={cn(
            'container-pd h-14 lg:h-20 gap-x-4 lg:gap-x-12 flex items-center relative z-50 transition-all bg-[var(--header-bg)]',
            className
          )}
        >
          <aside className='flex items-center gap-x-2'>
            <HeaderMenuButton />
            <LinkHome className='w-35.5 lg:w-47.5'>
              <Logo className='fill-[var(--header-logo)] w-35.5 h-auto lg:w-47.5 transition-[width]' />
            </LinkHome>
          </aside>
          <Nav />
          <a href={`mailto:${process.env.NEXT_PUBLIC_SUPPORT_EMAIL}`} className='ml-auto'>
            <Button
              size='small'
              outline
              arrow
              bgTransparent
              className='whitespace-nowrap h-8 lg:h-10 px-2 lg:px-4 text-[var(--header-btn-text)] border-current hover:text-[var(--header-btn-hover-text)] hover:border-[var(--header-btn-hover-border)]'
            >
              Contact Us
            </Button>
          </a>
        </header>
      </HeaderSticky>
      <Suspense>
        <MobileMenu />
      </Suspense>
    </HeaderMenuContextProvider>
  )
}

export function HeaderPlaceholder({
  className = '',
  height = false,
}: {
  className?: string
  height?: boolean
}) {
  return (
    <div
      className={cn('-mt-14 lg:-mt-20', { 'h-14 lg:h-20': height }, className)}
    ></div>
  )
}
